export default {
  hero_badge: 'Recursos organizados · Guías · Actualizado con frecuencia',
  hero_title: 'USFans Spreadsheet — Encuentra, explora y organiza información de creadores',
  hero_subtitle: 'Explora un USFans Spreadsheet estructurado con recursos de creadores, guías útiles, comparativas, reseñas, información de envío y consejos de seguridad — todo en un centro fácil de usar.',
  hero_primary_cta: 'Explorar USFans Spreadsheet',
  hero_secondary_cta: 'Ver recursos de creadores',
  hero_dropdown_label: 'Elige una categoría para empezar',
  hero_dropdown_placeholder: 'Selecciona una categoría…',
  btn_spreadsheet: 'usfans spreadsheet',
  btn_buy_now: 'comprar ahora',
  categories_title: 'Explora las categorías de productos',
  categories_subtitle: 'Elige una categoría para ir directamente a los productos correspondientes del sitio web principal. Cada enlace se abre en una pestaña nueva para que puedas volver cuando quieras.',
  category_shoes: 'Zapatos',
  category_hoodies: 'Sudadera/Suéteres',
  category_tshirts: 'Camisetas',
  category_jackets: 'Chaquetas',
  category_pants: 'Pantalones/Bermudas',
  category_headwear: 'Gorros',
  category_sets: 'Conjuntos',
  category_underwear: 'Ropa interior/Calzoncillos',
  category_jersey: 'Jersey',
  category_accessories: 'Accesorios',
  category_bags: 'Bolsos',
  category_belts: 'Cinturones',
  category_perfumes: 'Perfumes',
  category_other: 'Otros artículos',
  about_title: '¿Qué es el USFans Spreadsheet?',
  about_p1: 'El USFans Spreadsheet es una forma sencilla y organizada de explorar productos e información de creadores relacionada con USFans. En lugar de buscar en páginas dispersas una a una, todo está agrupado en categorías claras — desde zapatos y sudaderas hasta bolsos, cinturones y perfumes — para que encuentres lo que buscas más rápido.',
  about_p2: 'Nuestro objetivo es facilitar la comprensión de la información. Reunimos guías, comparativas y consejos de seguridad en un solo lugar, y luego te conectamos con el sitio web principal, donde vive toda la gama de productos. Somos un recurso independiente, no el sitio web oficial de USFans.',
  about_p3: 'Tanto si exploras por primera vez como si comparas opciones antes de comprar, la hoja te ofrece un punto de partida limpio. Usa los botones de categorías o el menú desplegable para ir directamente a los productos que te interesan.',
  article_section_title: 'Guías, reseñas y consejos de USFans',
  article_section_subtitle: 'Explora nuestra biblioteca de artículos detallados sobre USFans: hojas de cálculo, reseñas, envíos, ofertas, seguridad y más.',
  article_card_title: '¿Qué es un USFans Spreadsheet?',
  article_card_excerpt: 'Una guía completa y apta para principiantes que cubre qué es un USFans Spreadsheet, qué puedes encontrar dentro y cómo usarlo para explorar productos e información de creadores de forma segura.',
  article_read_more: 'Leer la guía completa',
  cta_title: '¿Listo para explorar toda la gama?',
  cta_text: 'Explora categorías y guías organizadas aquí, y luego visita el sitio web principal para ver la selección completa de productos.',
  cta_primary: 'Visitar el sitio web principal',
  cta_secondary: 'Explorar USFans Spreadsheet',
};